import { useMutation, useQueryClient } from 'react-query';
import { SearchEntity } from 'v2/models';

import { getKey as getSearchDetailsKey } from 'v2/queries/searches/useSearchDetails';
import restFactory from 'v2/utils/restFactory';

export function getIsSearchRenewable({
  free,
  expires_at,
}: Pick<SearchEntity, 'expires_at' | 'free'>) {
  return free && new Date(expires_at).getTime() < Date.now();
}

export function useRenewSearch(searchId: number) {
  const queryClient = useQueryClient();
  return useMutation(['renewSearch', searchId], async () => {
    await restFactory.post(`/dj/api/v1/search/${searchId}/renew/`, {});
    queryClient.invalidateQueries(getSearchDetailsKey(searchId));
  });
}
